import React from "react";
import { ReactSVG } from "react-svg";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import { GoArrowUpRight } from "react-icons/go";
import { NavLink } from "react-router-dom";
import { useInView } from "react-intersection-observer";

const bannerImage = process.env.PUBLIC_URL + "/images/banner-image.svg";
const bannerImageMobile = process.env.PUBLIC_URL + "/images/banner-image-mobile.svg";

const Banner = () => {
  const { ref: iconRef, inView: iconView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className=" w-full flex md:flex-row flex-col md:gap-8 gap-4  bg-[#EBF7FE] z-[5] rounded-3xl overflow-hidden pt-6 md:pl-6 md:mb-10">
      <div className=" md:flex-1 flex flex-col gap-4 pb-6 md:pl-0 pl-4">
        <div
          ref={iconRef}
          className={`${
            iconView ? `animate-scaleIn anim-preserve` : "opacity-0"
          }`}
        >
          <ReactSVG
            src={zeroTypingLogo}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
            }}
            className="w-auto"
          />
        </div>
        <div
          ref={headingRef}
          className={`${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] font-jakarta tracking-tight leading-tight font-semibold text-black`}
        >
          <span className="text-[#3AB1F6]">Supercharge</span> your productivity
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-[#EBF7FE] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter font-medium text-[#00000099]">
          Organize tasks, collaborate on docs, track goals, and streamline team
          communication—all in one place, enhanced by AI.
        </div>
        <NavLink
          to={"/download"}
          ref={buttonRef}
          className={`${
            buttonView ? " animate-scaleIn anim-preserve" : "opacity-0"
          } w-max text-[0.938rem] group text-white font-semibold font-inter flex items-center gap-2 p-2 pl-5 rounded-full bg-[#3AB1F6]`}
        >
          Get Started{" "}
          <span className=" bg-white text-[#3AB1F6] lg:p-2 p-1.5 rounded-full group-hover:rotate-45 transition-all duration-200">
            <GoArrowUpRight className="lg:size-5 size-4" />
          </span>
        </NavLink>
      </div>
      <div className="md:flex-1 md:flex hidden justify-end overflow-hidden ">
        <ReactSVG
          src={bannerImage}
          className="xl:w-[80%] w-[95%] 2xl:w-[65%] h-auto lg:h-[340px] xl:h-[360px] 2xl:h-[310px] relative -bottom-20 md:-bottom-24 lg:-bottom-14 xl:-bottom-16 2xl:-bottom-10 -right-6 border-[.65rem] shadow-5xl  shadow-[-25px_-25px_30px_-10px_#3AB1F670] border-[#3AB1F614] overflow-hidden rounded-tl-[32px]"
          beforeInjection={(svg) => {
            svg.classList.add("w-full", "h-auto");
          }}
        />
      </div>
      <div className=" flex md:hidden justify-center overflow-hidden pt-10 ">
        <ReactSVG
          src={bannerImageMobile}
          className="w-[85%] h-auto relative bottom-0 mx-auto border-[.75rem] border-b-0 shadow-[0_-25px_25px_-10px_#3AB1F670,25px_0_25px_-10px_#3AB1F670,-25px_0_25px_-10px_#3AB1F670] border-[#3AB1F614] rounded-[30px] rounded-b-none  "
          beforeInjection={(svg) => {
            svg.classList.add("w-full", "h-auto", "rounded-t-2xl");
          }}
        />
      </div>
    </div>
  );
};

export default Banner;
